const appConfig = {
  development: {
    API_URL: 'http://www.xport-e.com/api', // 测试环境 外网不需要VPN
    BASE: 'xcp'
  },
  test: {
    API_URL: '/api',
    BASE: 'xcp'
  },
  production: {
    API_URL: '/api',
    BASE: 'xcp'
  }
}

export default {
  CLIENT: 'xcp',
  AUTH_KEY: 'Authorization-Xcp',
  API_TIMEOUT: 10000, // 接口请求超时时间
  PROJECT_KEY: 'CROSS_XCP',
  ...appConfig[process.env.NODE_ENV]
}
